















import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import {
  namespace,
} from 'vuex-class';
import ExpandVue from '@/components/Expand.vue';
import MoreOnVue from '@/components/MoreOn.vue';
import EmploymentItemVue from '@/components/EmploymentItem.vue';
import EmploymentTagVue from '@/components/EmploymentTag.vue';
import { IEmployment, IPersona } from '@/@types';
import { UseFluid } from '@/mixins';

const employmentModule = namespace('employment');
const personaModule = namespace('persona');

@Component({
  components: {
    EmploymentItemVue,
    EmploymentTagVue,
    ExpandVue,
    MoreOnVue,
  },
})
export default class Employment extends Mixins(UseFluid) {
  @employmentModule.State('activeTags') public activeTags!: string[];
  @employmentModule.State('employments') public employments!: IEmployment[];
  @employmentModule.Getter('filteredEmployments') public filteredEmployments!: IEmployment[];
  @employmentModule.Getter('hasFilters') public hasFilters!: boolean;
  @employmentModule.State('tags') public tags!: string[];
  @personaModule.Getter('currentPersona') public currentPersona!: IPersona;
  @personaModule.Getter('hasActivePersona') public hasActivePersona!: boolean;
  @personaModule.Getter('employments') public personaEmployments!: IEmployment[];

  public get computedEmployments(): IEmployment[] {
    return this.hasActivePersona ? this.personaEmployments : this.filteredEmployments;
  }

  public get viewLimit(): number {
    return this.hasFilters ? 99 : 6;
  }
}
